import React from 'react';
import * as PropTypes from 'prop-types';
import { ButtonGroup, Nav } from 'react-bootstrap';
import ConceptStatus from '../../containers/ConceptStatus';
import ToolbarButton from '../Common/ToolbarButton';
import { Loading } from '../Loading/Loading';
import { STATUS_OFF } from '../../constants/common';
import { EyeIcon, WrenchIcon } from '../Common/Icons';

const Toolbar = ({
  title,
  nodeStatus,
  config,
  graphics,
  disabled,
  openWorkArea,
  toggleGraphics,
}) => (
  <div className="d-flex flex-column sidebar-nav" role="complementary" aria-label={`${title} toolbar`}>
    {disabled && <Loading showIcon={false} />}
    <div className="box box-min">
      <h1 className="title">{title}</h1>
    </div>
    <div className="box box-scroll engineering-toolbar">
      {config.map(
        (section) =>
          section.status !== 'hidden' && (
            <Nav className="flex-column" key={section.id}>
              <Nav.Item className="nav-header mb-1">{section.title}</Nav.Item>
              {section.tools.map((tool) => (
                <Tool
                  key={tool.node}
                  graphicsStatus={graphics[tool.node] || STATUS_OFF}
                  workAreaStatus={nodeStatus[tool.node] || STATUS_OFF}
                  openWorkArea={openWorkArea}
                  toggleGraphics={toggleGraphics}
                  {...tool}
                />
              ))}
            </Nav>
          )
      )}
    </div>
    <div className="d-flex">
      <ConceptStatus />
    </div>
  </div>
);
Toolbar.defaultProps = {
  title: '',
  config: [],
  nodeStatus: {},
  graphics: {},
  disabled: false,
};
Toolbar.propTypes = {
  title: PropTypes.string,
  config: PropTypes.array,
  nodeStatus: PropTypes.object,
  graphics: PropTypes.object,
  disabled: PropTypes.bool,
  openWorkArea: PropTypes.func,
  toggleGraphics: PropTypes.func,
};

const Tool = ({
  title,
  node,
  workArea,
  graphics,
  workAreaStatus,
  graphicsStatus,
  openWorkArea,
  toggleGraphics,
}) => (
  <Nav.Item className="d-flex justify-content-between align-items-center">
    {title}
    <ButtonGroup className="float-end" size="md">
      <ToolbarButton
        enabled={!!workArea}
        status={workAreaStatus}
        iconComponent={WrenchIcon}
        handleClick={() => openWorkArea(node)}
        ariaLabel={`Open work area for ${title}`}
      />
      <ToolbarButton
        enabled={!!graphics}
        status={graphicsStatus}
        iconComponent={EyeIcon}
        handleClick={() => toggleGraphics(node)}
        ariaLabel={`Toggle view for ${title}`}
      />
    </ButtonGroup>
  </Nav.Item>
);
Tool.propTypes = {
  node: PropTypes.string,
  title: PropTypes.string,
  workArea: PropTypes.number,
  graphics: PropTypes.number,
  status: PropTypes.object,
};
Tool.defaultProps = {
  node: '',
  title: '',
  workArea: 0,
  graphics: 0,
  status: {},
};

export default Toolbar;
